import { useEffect, useState } from "react";

export default function useHasWaitedXSecondsForNewVersion(
  waitDurationSeconds: number
) {
  const [hasWaitedXSecondsForNewVersion, sethasWaitedXSecondsForNewVersion] =
    useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      sethasWaitedXSecondsForNewVersion(true);
    }, waitDurationSeconds * 1000);

    return () => clearTimeout(timeout);
  }, [waitDurationSeconds]);

  return {
    hasWaitedXSecondsForNewVersion
  };
}
